<style lang="scss" scoped>
img {
  cursor: pointer;
  max-width: 350px;
  max-height: 350px;

  &:hover {
    box-shadow: 0 0 5px 4px #666;
  }
}
</style>

<template>
  <div class="card">
    <div class="card-body p-0" id="tenorCard">
      <div v-if="!loading" class="d-flex">
        <input
          @keydown.enter="queryTenor()"
          class="form-control"
          placeholder="Suchen"
          v-model="search"
        />
        <button @click="queryTenor()" class="btn btn-primary">
          Suchen
        </button>
      </div>
      <div class="container text-center pl-1 pr-1">
        <img
          @click="
            $emit('send-gif', gif.media[0].gif.url) && $modal.hide(modalName)
          "
          v-for="(gif, index) in gifs"
          class="w-100 p-1"
          :key="index"
          :src="gif.media[0].gif.url"
        />
      </div>
    </div>
    <div v-if="loading" class="card-body p">
      <div class="d-flex justify-content-around">
        <i class="fas fa-spinner fa-spin fa-10x"></i>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["name"],
  data() {
    return {
      gifs: [],
      search: "",
      modalName: "tenor",
      next: null,
      bottom: false,
      loading: true,
      cardElement: null,
      wrapperElement: null
    };
  },
  created() {
    if (this.name) {
      this.modalName = this.name;
    }

    this.queryTenor();
  },
  mounted() {
    this.cardElement = document.getElementById("tenorCard");
    this.wrapperElement = this.cardElement.parentNode.parentNode.parentNode.parentNode;
    this.wrapperElement.addEventListener("scroll", () => {
      this.bottom = this.bottomVisible();
    });
  },
  methods: {
    queryTenor(lastSearch = null) {
      this.loading = true;
      let searchParams = {
        locale: "de_DE",
        key: "SP4SMSIAG3KN",
        q: this.search === "" ? "excited" : this.search,
        limit: 20
      };
      if (lastSearch !== null) {
        searchParams.pos = lastSearch;
      }
      this.$http({
        method: "GET",
        url: "https://api.tenor.com/v1/search",
        params: searchParams,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/x-www-form-urlencoded"
        },
        withCredentials: false
      })
        .then(({ data }) => {
          this.next = data.next;
          if (lastSearch === null) {
            this.gifs = data.results;
          } else {
            this.gifs = this.gifs.concat(data.results);
          }
        })
        .finally(() => {
          this.loading = false;
        });
      if (this.bottomVisible && !this.loading)
        this.bottom = this.bottomVisible();
    },
    bottomVisible() {
      const scrollY = this.wrapperElement.scrollTop;
      const visible = document.documentElement.clientHeight;
      const pageHeight = this.cardElement.scrollHeight;
      const bottomOfPage = visible + scrollY >= pageHeight - 100;
      return bottomOfPage || pageHeight < visible;
    }
  },
  watch: {
    bottom(bottom) {
      if (bottom && !this.loading) this.queryTenor(this.next);
    }
  }
};
</script>
